<div
  class="panel_icon-close--left"
  (click)="onClose()">
  <fa-icon [icon]="['fal', 'times']"></fa-icon>
</div>

<div class="panel_title">Edit reference</div>

<span class="token_item token_item--single token_item--dark">
  <ng-container *ngIf="item.article?.authors?.length, else unknownAuthorTemplate">
    {{ item.article?.authors[0] | truncate }}&#44; 
  </ng-container>
  <ng-template #unknownAuthorTemplate>
    Unknown author&#44; 
  </ng-template>
  {{ item.article?.year ?  item.article?.year : getYear(item)}}
</span>

<br>
<br>

<p class="text--sm">
  Edits made to this reference will only apply to this citation in the current document. 
  To modify the metadata for all instances of this citation, please edit the reference in the Papers desktop or 
  <a (click)="onEditArticleClick()" class="text--link">web app</a>.
</p>

<br>

<form *ngIf="form" [formGroup]="form">

  <div class="row">
    <div class="col xs-6">
      <div class="form-group">
          <select 
            formControlName="positionName"
            id="positionName"
            class="form-control form-control--no-padding">
            <option 
              *ngFor="let option of positionOptions"
              [value]="option.id">
              {{ option.name }}
            </option>
          </select>
        <scs-field-error [control]="form.controls.positionName"></scs-field-error>
      </div>
    </div>

    <div  class="col xs-6">
      <div class="form-group">
        <input
          formControlName="positionValue"
          id="positionValue"
          class="form-control"
          type="text">
        <scs-field-error [control]="form.controls.positionValue"></scs-field-error>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col sm-6">
      <div class="form-group">
        <label class="form-label" for="city">Prefix</label>
        <input
          formControlName="prefix"
          id="prefix"
          class="form-control"
          type="text">
        <scs-field-error [control]="form.controls.prefix"></scs-field-error>
      </div>
    </div>
    <div class="col sm-6">
      <div class="form-group">
        <label class="form-label" for="zipCode">Suffix</label>
        <input
          formControlName="suffix"
          id="suffix"
          class="form-control"
          type="text">
        <scs-field-error [control]="form.controls.suffix"></scs-field-error>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col sm-12">
      <div class="form-group">
        <input
          type="checkbox"
          class="checkbox_input"
          formControlName="suppressAuthor"
          id="suppressAuthor">
        <label 
          for="suppressAuthor"
          class="checkbox_label">
          Suppress Author
        </label>
        <scs-field-error [control]="form.controls.suppressAuthor"></scs-field-error>
      </div>
    </div>
  </div>
</form>

<div class="drawer drawer--panel">
  <div 
    class="button-primary button-primary--sm"
    (click)="onSave()">
    Done
  </div>
  <div 
    class="button-primary button-primary--sm button-primary--white"
    (click)="onCancel()">
    Cancel
  </div>
</div>

